import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import { UserBalanceDisplayProps } from "./types";
import { addCanBeSelected } from "@helpers/shared";
import WalletItem from "./WalletItem";

export default observer(function UserBalanceDisplay({
	isInMenu,
}: UserBalanceDisplayProps) {
	const rootStore = useRootAppStore();
	const numberOfWallets = rootStore.userAuthStore.userAccounts?.length;

	if (!rootStore.userAuthStore.userAccounts) {
		return null;
	}

	if (!isInMenu) {
		const wallet =
			rootStore.userAuthStore.userAccounts?.find(
				(account) =>
					account.accountTypeId ===
					rootStore.userAuthStore.activeAccountTypeId
			) || rootStore.userAuthStore.userAccounts?.[0];

		return (
			<WalletItem
				isInMenu={isInMenu}
				wallet={wallet}
				numberOfWallets={numberOfWallets}
			/>
		);
	}

	const userWalletsMapped = addCanBeSelected(
		rootStore.userAuthStore.userAccounts || [],
		rootStore.userAuthStore
	);

	return (
		<>
			{userWalletsMapped.map((wallet) => {
				return (
					<WalletItem
						key={wallet.id}
						isInMenu={isInMenu}
						wallet={wallet}
						numberOfWallets={numberOfWallets}
					/>
				);
			})}
		</>
	);
});
